import { formatGMTDateToJavascriptDate } from '@/business/utils/dates';
import axios from 'axios';

const treatsCurrent = ({
  datetimeFieldNames = [],
  booleanFieldNames = [],
  JSONFieldNames = [],
}) => (entry) => {
  const treated = { ...entry };
  datetimeFieldNames.forEach((field) => {
    if (field.arrayFieldName) {
      entry[field.arrayFieldName].forEach((neastedItem, index) => {
        field.arrayFields.forEach((neastedField) => {
          treated[field.arrayFieldName][index][
            neastedField
          ] = formatGMTDateToJavascriptDate(
            entry[field.arrayFieldName][index][neastedField]
          );
        });
      });
    } else {
      treated[field] = formatGMTDateToJavascriptDate(treated[field]);
    }
  });
  booleanFieldNames.forEach((field) => {
    treated[field] = treated[field] === 'O';
  });
  JSONFieldNames.forEach((field) => {
    try {
      treated[field] = JSON.parse(entry[field]);
    } catch (e) {
      treated[field] = {
        Parsing_error: entry.payload,
      };
    }
  });
  return treated;
};

/**
 * Business function. Treats entries from API.
 * @param {object} response The response of the API
 * @returns {object} The response treated.
 */
const treatsItems = ({ datetimeFieldNames, booleanFieldNames }) => (response) =>
  response.data.items &&
  response.data.items.map(
    treatsCurrent({ datetimeFieldNames, booleanFieldNames })
  );
/**
 * Business function. Treats entry from API.
 * @param {object} response The response of the API
 * @returns {function(*): *} The response treated.
 */
const treatsItem = ({
  datetimeFieldNames,
  booleanFieldNames,
  JSONFieldNames,
}) => (response) => {
  const res = response.data.items;
  if (!res.length) {
    throw new Error('Item not Found');
  }
  return treatsCurrent({
    datetimeFieldNames,
    booleanFieldNames,
    JSONFieldNames,
  })(res[0]);
};

const errorHandler = (error) => {
  if (error.response) {
    // eslint-disable-next-line
    console.log(
      'The request was made and the server responded with a status code != 2xx',
      error.response
    );
  } else if (error.request) {
    // eslint-disable-next-line
    console.log(
      'The request was made but no response was received',
      error.request
    );
  } else if (axios.isCancel(error)) {
    // eslint-disable-next-line
    console.log(error.message);
  } else {
    // eslint-disable-next-line
    console.log(
      'Something happened in setting up the request that triggered an Error',
      error.message
    );
  }
  throw error;
};

export { treatsItems, treatsItem, treatsCurrent, errorHandler };
